export const getEditedCommentId = state => state.commentEdit;
export const isEditingComment = state => Boolean(getEditedCommentId(state));



// WEBPACK FOOTER //
// ./app/selectors/edited-comment-id-selectors.js